export { RetailCustomerConfigurationService } from './retail-customer-configuration.service';
export * from './retail-customer-configuration';
